import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Department() {
    const { t } = useLang();
    return (
        <div data-testid="department-page">
            <section className="bg-[#1A365D] text-white pt-20 pb-16 md:pt-28 md:pb-24">
                <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
                    <div className="small-caps text-[#F5B76E] mb-4">
                        {t.department.eyebrow}
                    </div>
                    <h1 className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl">
                        {t.department.title}
                    </h1>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-white">
                <div className="max-w-4xl mx-auto px-6 md:px-12">
                    <p className="text-lg leading-relaxed text-gray-700 mb-16 border-l-4 border-[#DD6B20] pl-6 italic font-serif">
                        {t.department.intro}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
                        <div>
                            <div className="small-caps text-[#DD6B20] mb-3">
                                {t.department.visionTitle}
                            </div>
                            <h2 className="font-serif text-2xl font-semibold text-[#1A365D] mb-4">
                                {t.department.visionTitle}
                            </h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t.department.visionBody}
                            </p>
                        </div>
                        <div>
                            <div className="small-caps text-[#DD6B20] mb-3">
                                {t.department.missionTitle}
                            </div>
                            <h2 className="font-serif text-2xl font-semibold text-[#1A365D] mb-4">
                                {t.department.missionTitle}
                            </h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t.department.missionBody}
                            </p>
                        </div>
                    </div>

                    <div className="bg-[#F7FAFC] p-8 md:p-12 rounded-lg border border-gray-200">
                        <div className="small-caps text-gray-500 mb-3">
                            {t.department.objectivesTitle}
                        </div>
                        <h2 className="font-serif text-2xl md:text-3xl font-semibold text-[#1A365D] mb-8">
                            {t.department.objectivesTitle}
                        </h2>
                        <ul className="space-y-4">
                            {t.department.objectives.map((obj, i) => (
                                <li
                                    key={i}
                                    className="flex items-start gap-4"
                                    data-testid={`objective-${i}`}
                                >
                                    <CheckCircle2
                                        size={20}
                                        className="text-[#DD6B20] mt-0.5 flex-shrink-0"
                                    />
                                    <span className="text-gray-700 leading-relaxed">{obj}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
}
